import React from "react";
import store from '../../store/store'
import { InputItem,Button,Toast } from 'antd-mobile';
import "./login.scss"
import {logining,getUserMenu} from "../../api/index"
export default class Login extends React.Component{
    constructor(props){
        super(props);
        this.state={
            account:"",
            password:""
        }
        
    }
    changeAccount(e){
        this.setState({
            account:e
        })
    }
    changePassword(e){
        this.setState({
            password:e
        })
    }
    async enter(){
        let _this=this;
        let obj={
            account: this.state.account,
            password: this.state.password,
        }
        logining(obj).then(res => {
            if (res.code == 0) {
            //   try {
            //     FileCL.GetUserInfo(res.data.token);
            //     let ress=PrintLabel.AddAccount(JSON.stringify({UserAccount:this.form.account,UserPwd:this.form.password}))
            //     console.log("ressss......",ress);
            //   } catch (err) {
  
            //   };
              sessionStorage.setItem('token', res.data.token);
              sessionStorage.setItem('userInfo', JSON.stringify(res.data));
                
            } else {
                Toast.fail(res.msg, 2)
                
            }
            return res
          }).then(async (res) => {
            if(res.code!=0){
                return
            }
            let res1 = await getUserMenu(res.data.id);
            if (res1.code == 0) {
              res1.data.children=res1.data.children.filter((s)=>{return s.name=="系统首页"});
              if (res1.data.children.length) {
                function treesort(data) {
                  data.sort((a, b) => {
                    if (a.sort - b.sort == 0) {
                      return 0
                    }
                    if (a.sort - b.sort > 0) {
                      return 1
                    }
                    if (a.sort - b.sort < 0) {
                      return -1
                    }
                  })
  
                  data.forEach(item => {
                    if (item.children.length) {
                      treesort(item.children)
                    }
                  });
                }
                treesort(res1.data.children);
                let arr = [];
  
                function getbtn(data) {
  
                  if (data.children.length) {
                    data.children.forEach((item) => {
                      if (item.type == 3) {
                        arr.push({
                          id: item.id,
                          name: item.name,
                          url: item.url,
                          type: item.type,
                          perms: item.perms,
                          parentId: item.parentId
                        })
                      }
                      getbtn(item);
                    })
                  }
                }
                getbtn(res1.data);

                // this.$store.commit("SET_PORWE", res1.data); //保存所有权限
                // this.$store.commit("SET_BTN", arr); //保存所有按钮权限
                // console.log()
                sessionStorage.setItem('PORWE', JSON.stringify(res1.data.children));
                // store.dispatch({
                //   type:"POWER",
                //   data:res1.data.children
                // })
                Toast.success("登陆成功!", 1)
                _this.props.history.push("/TopHome")
              } else {
                Toast.fail("此账号获取权限为空，请设置后再登录！",3)
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userInfo');
              }
  
            }else{
              Toast.fail(res1.msg,3)
            }
          });
    }
    render(){
        
        return(
            <div className="Login">
                <p className="title">登录</p>
                <div className="formWrap">
                    <p className="formTitle">帐号</p>
                    <InputItem
                        value={this.state.account}
                        clear
                        placeholder="请输入您的帐号"
                        onChange={(e)=>{this.changeAccount(e)}}
                    ></InputItem>
                    <p className="formTitle">密码</p>
                    <InputItem
                        value={this.state.password}
                        type="password"
                        clear
                        placeholder="请输入您的密码"
                        onChange={(e)=>{this.changePassword(e)}}
                    ></InputItem>
                </div>
                <Button type="primary" onClick={()=>{this.enter()}}>登录</Button>
            </div>
            
        )
    }
    componentDidMount(){
        
    }
}

